export const fetchAllUnloadsQueryKey = () => ['unloads'];
export const getUnloadQueryKey = (unloadId: number | string | undefined) => [
  'unload',
  unloadId || 0,
];

export const getUnloadTrendQueryKey = (
  unloadId: number | string | undefined,
) => ['unload', 'trend', unloadId || 0];
